import { useEffect, useState, useRef } from "react";
import "./UserAccounts.scss";
import {
  getFeeExempt,
  setFeeExempt,
  createUserTransactionsHoldingAccounts,
  userUpdateTelephoneVerification,
  OFACCheck3,
} from "../../../util/API/customers";
import CardTick from "../../../images/card-tick.svg";
import Compliance from "../../../images/shield-search-gray.svg";
import ProfileCircle from "../../../images/profile-circle.svg";
import CardSlash from "../../../images/card-slash.svg";
import { getDailyLimit } from "../../../util/API/customers";
import AccountActionsModal from "../../AccountActionsModal/AccountActionsModal";
import {
  getExternalAccountBalance,
  getExternalAccounts,
} from "../../../util/API/externalaccounts";
import { CalculateRiskScore } from "../../../util/API/customers";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import {
  Box,
  Select,
  Typography,
  MenuItem,
  styled,
} from "@mui/material";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { commonRunQuery } from "../../../util/API/loans";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useSelector } from "react-redux";

function UserAccounts({ selectedUser, selectedUserData, isSuperAdmin, setSelectedUserData }) {
  const [open, setOpen] = useState(false);
  const [dailyMax, setDailyMax] = useState();
  const [loading, setLoading] = useState(false);
  const [externalAccounts, setExternalAccounts] = useState([]);
  const [selectedExternalAccount, setSelectedExternalAccount] = useState(null);
  const [externalBalance, setExternalBalance] = useState({});
  const [riskScore, setRiskScore] = useState("");
  const [purpose, setPurpose] = useState("");
  const [exempt, setExempt] = useState("");
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
  });
  const [ofacFlagged, setOfacFlagged] = useState(null);

  const previousExternalBalanceRef = useRef({}); // Track previous value of externalBalance
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  let configVariables = useSelector((state) => state.config.baseConfig);

  let isOperator = sessionStorage.getItem("isOperator");
  let isAgent = sessionStorage.getItem("isAgent");
  let isOFACEnabled = configVariables.ofacImplementation;

  const handleClose = () => setOpen(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const StyledMenuItem = styled(MenuItem)({
    padding: "0 8px",
    lineHeight: "1.5",
    textAlign: "center",
  });

  const StyledSelect = styled(Select)({
    "& .MuiSelect-select": {
      padding: "6px 6px",
      textAlign: "right",
      fontSize: "14px",
    },
  });

  async function getUserBalance() {
    let limitResponse = await getDailyLimit(selectedUser);
    if (limitResponse.data) {
      setDailyMax(limitResponse.data.ServiceData);
    } else {
    }
    setLoading(false);
  }

  async function getUserAccounts() {
    let response = await getExternalAccounts(selectedUser);
    let records = response.payload?.record;
    if (!records) return;
    if (!Array.isArray(records)) {
      records = [records];

     
    }
     console.log(records);
    const transactionAccounts = records.filter((account) =>
      account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
    );
    const otherAccounts = records.filter(
      (account) =>
        !account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
    );
    const sortedAccounts = transactionAccounts.concat(otherAccounts);
    setExternalAccounts(sortedAccounts);
    setSelectedExternalAccount(sortedAccounts[0]?.Vuserpi3.id);
  }

  async function getRiskScore() {
    if (selectedExternalAccount > 0) {
      let response = await CalculateRiskScore(
        externalAccounts.filter(
          (account) => account["Vuserpi3"]?.id === selectedExternalAccount
        )[0]["Vuserpi3"]?.id,
        externalAccounts.filter(
          (account) => account["Vuserpi3"]?.id === selectedExternalAccount
        )[0]["Vuserpi3"]?.userid,
        selectedUserData ? selectedUserData["User"].langID : "EN"
      );
      setRiskScore(
        response?.riskscore === "1"
          ? "Low"
          : response?.riskscore === "2"
          ? "Medium"
          : "High"
      );
    } else {
      setRiskScore("Medium");
    }
  }

  async function getExempt() {
    const response = await getFeeExempt(selectedExternalAccount, selectedUser);
    setExempt(response?.payload?.data?.body?.userpi?.servicefeeexempted);
    setPurpose(response?.payload?.data?.body?.userpi?.purposeofaccount);
  }

  async function getUserExternalAcctBalance() {
    let response = await getExternalAccountBalance(
      selectedUser,
      selectedExternalAccount
    );
    setExternalBalance(response?.payload || {});
  }

  useEffect(() => {
    getUserAccounts();
    getUserBalance();
    isOFACEnabled && getUserOFACScore();
  }, [selectedUser]);

  useEffect(() => {
  if (selectedUser && selectedExternalAccount) {
    getRiskScore();
    getExempt();
  }
}, [selectedUser, selectedExternalAccount]);

  useEffect(() => {
    if (selectedExternalAccount !== null) {
      getUserExternalAcctBalance();
    }
  }, [selectedExternalAccount]);

  useEffect(() => {
    if (
      JSON.stringify(previousExternalBalanceRef.current) !==
      JSON.stringify(externalBalance)
    ) {
      getUserExternalAcctBalance();
    }
    previousExternalBalanceRef.current = externalBalance;
  }, [externalBalance]);

  const getUserOFACScore = async() => {
    try {
      const response = await commonRunQuery(313, selectedUser);
      console.log("getUserOFACScore_response===========",response);
      if(response?.data?.header?.callStatus == '1' && parseInt(response?.data?.header?.reccount) > 0 ) {
        if(parseInt(response?.data?.body?.record?.userofac_history?.score) > 0) {
          setOfacFlagged(true);
        } else {
          setOfacFlagged(false);
        }
      }
    } catch (error) {
    }
  }

  const addFundsNoBalance = (
    <Box className="no-balance-container">
      This user currently does not have a balance.
      <Box className="d-flex justify-content-end"></Box>
    </Box>
  );

  const noBalance = (
    <Box>{selectedUser ? addFundsNoBalance : "Please select a user"}</Box>
  );

  const handleSubmit = async () => {
    const response = await setFeeExempt(
      selectedExternalAccount,
      selectedUser,
      exempt,
      purpose
    ).then((response) => {
      if (response.callStatus == "1") {
        setAlert({
          showAlert: true,
          message: `${response.msg}`,
          severity: "success",
          header: "Congratulations!",
        });
      } else {
        setAlert({
          showAlert: true,
          message: `${response.payload.msg}`,
          severity: "error",
          header: "Error!",
        });
      }
    });
  };

  const handleAccountCreate = async(accountType) => {
    try {
      const response = await createUserTransactionsHoldingAccounts(selectedUser, accountType, agent['User'].id, selectedUserData?.Useremailaccount?.emailAccount, "", purpose, exempt);
      if(response?.payload?.callStatus == '1'){
        setAlert({
          showAlert: true,
          message: `User's ${accountType == 0 ? 'Transactions Account' : 'Holdings Account'} created successfully.`,
          severity: "success",
          header: "Congratulations!",
        });
        getUserAccounts();
      }

    } catch (error) {
      setAlert({
        showAlert: true,
        message: "Failed to create user account. " + error,
        severity: "error",
        header: "Error",
      });
    }
  };

  function getFormattedUnavailableBalance(externalBalance) {
    // Safely check if externalBalance and unavailablebalance are defined
    if (
      !externalBalance ||
      externalBalance.unavailablebalance === null ||
      externalBalance.unavailablebalance === undefined
    ) {
      return "$0.00"; // Return default value when unavailablebalance is not available
    }

    const unavailableBalance = externalBalance.unavailablebalance;
    return (
      "$" +
      (
        parseFloat(unavailableBalance.replace(/[^\d.-]/g, "") || "0") * -1
      ).toFixed(2)
    );
  }

  const hasHoldingsAccount = externalAccounts.some(
    (account) => account.Vuserpi3.piname === "Holdings" || account.Vuserpi3.piname === "Holdings Account" || account.Vuserpi3.piname === "Savings Account"
  );

  const hasTransactionsAccount = externalAccounts.some(
    (account) => account.Vuserpi3.piname === "Transactions Account" || account.Vuserpi3.piname == "Chequing Account"
  );

  const handleTelephoneVerification = async() => {
    try {
      const response = await userUpdateTelephoneVerification(selectedUser);
      if(response?.data?.header?.callStatus == "1") {
        setSelectedUserData(prevData => ({
          ...prevData,
          User: {
            ...prevData.User,
            telephoneverified: 1
          }
        }));
        setAlert({
          showAlert: true,
          message: `Telephone Account Verified!`,
          severity: "success",
          header: "Congratulations!",
        });
      } else {
        setAlert({
          showAlert: true,
          message: "Telephone account verification failed.",
          severity: "error",
          header: "Error",
        });
      }
    } catch (error) {
      console.log("handleTelephoneVerification_error=============",error);
    }
  }

  const handleOFACVerification = async() => {
    console.log("handleOFACVerification_response===========",agent['User'].id);
    try {
      setLoading(true);
      const response = await OFACCheck3(selectedUser, agent['User'].id);
      console.log("handleOFACVerification_response===========",response);
      if(response?.data?.header?.callStatus == "1") {
        getUserOFACScore();
      }
    } catch (error) {
      console.log("handleOFACVerification_error================",error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <AccountActionsModal
        open={open}
        handleClose={handleClose}
        selectedUserData={selectedUserData}
      />
      <Box className="user-accounts-tab">
        <Box className="accounts-tab-header">
          <Typography
            sx={{
              fontWeight: 800,
              color: "#6b7280",
              fontFamily: "Nunito",
              fontSize: "14px",
              fontStyle: "normal",
            }}
          >
            User Account Details
          </Typography>
          {externalAccounts && (
            <Box
              className="transaction-selector d-flex align-items-center gap-3"
              sx={{ display: "flex", gap: "20px" }}
            >
              <Box sx={{ marginLeft: "260px" }}>
                <Typography
                  sx={{
                    fontWeight: 800,
                    color: "#6b7280",
                    fontFamily: "Nunito",
                    fontSize: "14px",
                    fontStyle: "normal",
                    // lineHeight: "33.6px",
                  }}
                  className="selector-label-title"
                >
                  Account Types
                </Typography>
              </Box>
              <StyledSelect
                onChange={(e) => setSelectedExternalAccount(e.target.value)}
                className="select-style"
                value={selectedExternalAccount}
                sx={{
                  "& .MuiSelect-select": {
                    padding: "6px 6px",
                    textAlign: "right",
                    fontSize: "14px",
                  },
                }}
              >
                {externalAccounts.map((account) => {
                  const { friendlyname, cardno, piid } = account.Vuserpi3;
                  // Get last 4 digits if cardno is present and piid !== "229" (Transactions Account) and piid !== "230" (Holding Account)
                  const last4 = cardno?.slice(-4);
                  const showCardDigits = piid !== "229" && piid !== "230" && last4;

                  return (
                    <StyledMenuItem key={account.Vuserpi3.id} value={account.Vuserpi3.id}>
                      {friendlyname}
                      {showCardDigits ? ` - ${last4} ` : ""}
                    </StyledMenuItem>
                  );
                })}
              </StyledSelect>
            </Box>
          )}
        </Box>

        {loading ? (
          <Box className="text-center mt-5">
            <span className="loader" />
          </Box>
        ) : externalAccounts == null ? (
          noBalance
        ) : (
          <Box className="balance-container">
            <Box className="row">
              <Box className="accounts-information">
                <Box className="account-details">
                  <img src={ProfileCircle} loading="lazy" />
                  <Box className="account-info-type">Account Id:</Box>
                  <Box className="account-info-response">
                    {externalAccounts?.filter(
                      (account) =>
                        account["Vuserpi3"]?.id === selectedExternalAccount
                    )[0]?.["Vuserpi3"]?.acctID || "N/A"}
                  </Box>
                </Box>
                <Box className="account-details">
                  <img src={ProfileCircle} loading="lazy" />
                  <Box className="account-info-type">Risk Score:</Box>
                  <Box className="account-info-response">{riskScore}</Box>
                </Box>
                <Box className="account-details align-items-center">
                  <img src={CardTick} loading="lazy" />
                  <Box className="account-info-type">Account Balance:</Box>
                  <Box className="account-info-response">
                    ${externalBalance?.balance ? parseFloat(externalBalance?.balance) * -1 : 0.00}
                  </Box>
                </Box>
                <Box className="account-details">
                  <img src={CardSlash} loading="lazy" />
                  <Box className="account-info-type">Unavailable balance:</Box>
                  <Box className="account-info-response">
                    {externalBalance
                      ? getFormattedUnavailableBalance(externalBalance)
                      : 0.0}
                  </Box>
                </Box>
                <Box className="account-details">
                  <img src={Compliance} loading="lazy" />
                  <Box className="account-info-type"> ComplyAdvantage Score: </Box>
                  <Box className="account-info-response">
                  {!selectedUserData?.User?.screenresult || !selectedUserData?.User?.kyclevel ? "User not onboarded" :
                  selectedUserData?.User?.screenresult === "NEGATIVE" || 
                  (selectedUserData?.User?.kyclevel === "HIGH-RISK" || selectedUserData?.User?.kyclevel === "PROHIBITED") 
                  ? "Bad Score" : "Good Score"}
                  </Box>
                </Box>
                {isOFACEnabled && <Box className="account-details">
                  <img src={Compliance} loading="lazy" />
                  <Box className="account-info-type"> OFAC: </Box>
                  <Box className="account-info-response">
                    <Box>
                      {ofacFlagged === true ? (
                          <><CancelIcon style={{ color: 'red' }} /> (Flagged)</>
                        ) : ofacFlagged === false ? (
                          <><CheckCircleIcon style={{ color: 'green' }} />(Passed)</>
                        ) : "N/a"
                      }
                    </Box>
                    <BaseButton
                      buttonText={`Run OFAC`}
                      onClick={handleOFACVerification}
                      buttonStyle="save-button"
                      sx={{ marginBottom:"0px !important" }}
                      disabled={ false }
                    />
                  </Box>
                </Box>}

                {
                  isAgent == "true" || isOperator == "true" ? (
                  <Box className="account-details">
                    <img src={Compliance} loading="lazy" />
                    <Box className="account-info-type"> Telephone verified: </Box>
                    <Box className={`account-info-response`}>{selectedUserData?.User?.telephoneverified == "0" ? `Verify Telephone Account` : `Verified`}</Box>
                  </Box>
                  ) : (
                    <Box className="account-details">
                      <img src={Compliance} loading="lazy" />
                      <Box className="account-info-type"> Telephone verified: </Box>
                      <Box sx={{ width:"52%", display:"flex", justifyContent:"space-between" }}>
                        <Box className="account-info-response" sx={{  }}>{selectedUserData?.User?.telephoneverified == "0" ? `No` : `Yes`}</Box>
                        {/* <Box onClick={selectedUserData?.User?.telephoneverified == "0" ? handleTelephoneVerification : null} className={selectedUserData?.User?.telephoneverified == "0" ? `account-info-response cursor-pointer` : `account-info-response`}>{selectedUserData?.User?.telephoneverified == "0" ? `Verify Telephone Account` : `Verified`}</Box> */}
                        <BaseButton
                          buttonText={selectedUserData?.User?.telephoneverified == "0" ? `Verify Telephone Account` : `Verified`}
                          onClick={handleTelephoneVerification}
                          buttonStyle="save-button"
                          sx={{ marginBottom:"0px !important" }}
                          disabled={ selectedUserData?.User?.telephoneverified == "0" ? false : true }
                        />

                      </Box>
                    </Box>
                  )
                }
              </Box>
            </Box>
            <Box className="user-select-container row align-items-center gap-5">
              <Box className="transaction-selector col-4">
                <Box>
                  <Typography className="account-details">
                    Fee Exempt
                  </Typography>
                </Box>
                <StyledSelect
                  className="select-style"
                  value={exempt}
                  onChange={(e) => {
                    setExempt(e.target.value);
                  }}
                >
                  <StyledMenuItem value="0">No</StyledMenuItem>
                  <StyledMenuItem value="1">Yes</StyledMenuItem>
                </StyledSelect>
              </Box>
              <Box className="transaction-selector col-4">
                <Box>
                  <Typography className="account-details">
                    Purpose Of Account
                  </Typography>
                </Box>
                <StyledSelect
                  className="select-style"
                  value={purpose}
                  onChange={(e) => setPurpose(e.target.value)}
                >
                  <StyledMenuItem value="2">
                    Digital Wallet and payroll{" "}
                  </StyledMenuItem>
                  <StyledMenuItem value="3">Mastercard </StyledMenuItem>
                  <StyledMenuItem value="1">
                    Remittance transactions{" "}
                  </StyledMenuItem>
                </StyledSelect>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <BaseButton
                  buttonText={"Submit"}
                  onClick={handleSubmit}
                  buttonStyle="save-button"
                />

                {isSuperAdmin === "true" && <Box sx={{ display: "flex", gap: 2 }}>
                  <BaseButton
                    buttonText={"Create Holdings Account"}
                    onClick={() => handleAccountCreate(1)}
                    buttonStyle="save-button"
                    disabled={hasHoldingsAccount}
                  />
                  <BaseButton
                    buttonText={"Create Transactions Account"}
                    onClick={() => handleAccountCreate(0)}
                    buttonStyle="save-button"
                    disabled={hasTransactionsAccount}
                  />
                </Box>}
              </Box>
            </Box>
          </Box>
        )}
        <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={(prevDetails) =>
            setAlert({ ...prevDetails, showAlert: false })
          }
          autoclose={alert.severity === "error" ? false : true}
        />
      </Box>
    </>
  );
}

export default UserAccounts;
